import { useOrderViewStore } from '@/store/pinia/orderview.store';
import { isSwedishWorkflow } from '@/services/config.service';
import { computed } from 'vue';
import { UNTOUCHED } from '@/store/const';
import { STEPS } from '@/services/const.enum';
import  Vue from 'vue';
import type {Store} from 'vuex';
import {useSideDrawerStore} from '@/store/pinia/sidedrawer.store';

function registerSwedishProfile(orderViewStore: any, store: Store<any>) {
  Vue.component('SwedishProfile', () => import('./views/SwedishProfile.vue'));
  orderViewStore.addCard({
    name: STEPS.SWEDISH_PROFILE,
    step: () => store.getters['loggedIn'] ? STEPS.BILLING_PROFILE : STEPS.DOMAIN_PROFILE,
    isShown: computed(() => !store.getters['loggedIn']
      || store.getters['progressByUser'][STEPS.BILLING_PROFILE] !== UNTOUCHED),
    isReadOnly: computed(() => false),
  });
}

function registerBillingProfile(orderViewStore: any, store: Store<any>) {
  Vue.component('BillingProfile', () => import('./views/BillingProfile.vue'));
  orderViewStore.addCard({
    name: STEPS.BILLING_PROFILE,
    step: () => STEPS.BILLING_PROFILE,
    isShown: computed(() => !store.getters['loggedIn']
      || store.getters['progressByUser'][STEPS.BILLING_PROFILE] !== UNTOUCHED),
    isReadOnly: computed(() => false),
  });
}

function registerDomainProfile(orderViewStore: any, store: Store<any>) {
  Vue.component('DomainProfile', () => import('./views/DomainProfile.vue'));
  orderViewStore.addCard({
    name: STEPS.DOMAIN_PROFILE,
    step: () => STEPS.DOMAIN_PROFILE,
    isShown: computed(() => {
      return store.getters['loggedIn']
          && (isSwedishWorkflow || (store.getters['progressByUser'][STEPS.DOMAIN_PROFILE] !== UNTOUCHED
            && (store.state.cart.domainProfileRequired || store.getters['allDomainProfilesDefined'])));
    }
    ),
    isReadOnly: computed(() => store.getters['allDomainProfilesDefined']),
  });
}

export function registerProfilesSettingsInDrawer() {
  const sideDrawerStore = useSideDrawerStore();

  Vue.component('ProfilesSettingsInDrawer', () => import('./components/ProfilesSettingsInDrawer.vue'));
  sideDrawerStore.addSidebarItem({
    name: 'profiles-settings-in-drawer',
  });
}

export const setupProfiles = (store: Store<any>) => {
  const orderViewStore = useOrderViewStore();

  if (isSwedishWorkflow) {
    registerSwedishProfile(orderViewStore, store);
  } else {
    registerBillingProfile(orderViewStore, store);
  }

  registerDomainProfile(orderViewStore, store);
};
